/**
 * Copyright © Veeam Software Group GmbH.
 */

import { VirtualPlatformTypeRepresentation } from '@veeam-vspc/models/web-controllers';

export type VirtualPlatformTypeRepresentations = VirtualPlatformTypeRepresentation;
export const VirtualPlatformTypeRepresentations = VirtualPlatformTypeRepresentation;
